import React from 'react';
import { regulamento } from '../regulamento';

export const ContratoModal = ({
  checked,
  onChecked,
  onClose
}: {
  checked: boolean;
  onChecked: (checked: boolean) => void;
  onClose: () => void;
}) => (
  <div className="modal-contrato" onClick={onClose}>
    <div className="modal-contrato-content" onClick={(event) => event.stopPropagation()}>
      <div className="modal-contrato-header">
        <h3>REGULAMENTO COLÔNIA DE FÉRIAS 2026</h3>
        <button type="button" className="modal-close" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="modal-contrato-body">
        <pre className="contrato-texto">{regulamento}</pre>
      </div>
      <div className="modal-consentimento">
        <label className="checkbox-option">
          <input type="checkbox" checked={checked} onChange={(event) => onChecked(event.target.checked)} />
          <span className="checkbox-custom" />
          <span className="checkbox-text">Li e concordo com os termos do regulamento acima</span>
        </label>
        <button type="button" className="modal-accept-button" disabled={!checked} onClick={onClose}>
          Aceitar e prosseguir
        </button>
      </div>
    </div>
  </div>
);

export const GratuitoModal = ({ onClose }: { onClose: () => void }) => (
  <div className="modal-contrato">
    <div className="modal-contrato-content gratuito-modal">
      <div className="modal-contrato-header gratuito-header">
        <h3>INSCRIÇÃO GRATUITA</h3>
      </div>
      <div className="modal-contrato-body gratuito-body">
        <div className="gratuito-large-icon">🎁</div>
        <h4>Cobrança Zerada!</h4>
        <p>
          O código <strong>GRATUITO</strong> foi aplicado com sucesso. Você pode continuar o cadastro normalmente.
          Ao finalizar, nenhuma cobrança será gerada.
        </p>
        <button type="button" className="btn-primary-green" onClick={onClose}>
          Entendi, continuar cadastro
        </button>
      </div>
    </div>
  </div>
);
